import { X } from "lucide-react";
import React, { Dispatch, SetStateAction, memo } from "react";
import ChartSkeleton from "src/components/skeleton/ChartSkeleton";

interface DialogModalProps {
  title: string;
  message: React.ReactNode;
  show: boolean;
  minHeight?: string;
  isModalList?: boolean;
  disableHeight?: boolean;
  headerAccessory?: React.ReactNode;
  setShow: Dispatch<SetStateAction<boolean>>;
  handleOnClick?: (e: string) => void;
  isChart?: boolean;
  isPortfolio?: boolean;
  getData?: () => Promise<void>;
  noBackdrop?: boolean;
  loadingCharts?: boolean;
  maxWidth?: string;
  isUniverse?: boolean;
  isinsiderModal?: boolean;
}

const DialogModal = (props: DialogModalProps) => {
  const {
    show,
    setShow,
    minHeight,
    title,
    message,
    handleOnClick,
    isModalList,
    disableHeight,
    headerAccessory,
    isChart,
    isPortfolio,
    getData,
    noBackdrop,
    maxWidth,
    loadingCharts,
    isUniverse,
    isinsiderModal,
  } = props;

  const handleOnClickNo = () => {
    if (handleOnClick) handleOnClick("No");
    setShow(false);
  };

  if (!show) return null;

  const renderNoDataMessage = !message;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center backdrop-blur-md p-4 h-full"
      onClick={() => {
        if (isPortfolio && getData) {
          getData();
        }
        if (!noBackdrop) {
          handleOnClickNo();
        }
      }}
    >
      <div
        className={`w-full rounded-2xl overflow-hidden  shadow-2xl z-10 bg-white dark:bg-gray-900/90 ${minHeight} ${isChart ? "p-1" : "p-6"} relative ${isModalList ? "max-w-md" : maxWidth || "max-w-7xl lg:w-full m-4"} ${isinsiderModal ? "px-1 py-1" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className={`absolute ${isChart ? "top-2 right-3" : isUniverse ? "top-1 right-2" : "top-3 right-3"} text-gray-500 hover:text-gray-800 dark:text-gray-400 dark:hover:text-white cursor-pointer`}
          onClick={() => {
            if (isPortfolio && getData) {
              getData();
            }
            handleOnClickNo();
          }}
        >
          <X className="w-5 h-5" />
        </button>

        {!isModalList && (
          <div className="mb-2 flex items-start justify-between gap-2 pr-12">
            <div className="ml-3 flex min-w-0 flex-1 items-start gap-3">
              <h2
                className="shrink-0 text-lg font-semibold dark:text-white truncate"
                dangerouslySetInnerHTML={{ __html: title }}
              />
              {headerAccessory ? (
                <div className="min-w-0 flex-1 pt-2 mr-2">
                  {headerAccessory}
                </div>
              ) : null}
            </div>
          </div>
        )}

        <div
          className={`text-gray-700 dark:text-white mb-0 w-full ${
            isModalList || disableHeight ? "" : "h-100"
          }`}
        >
          {isChart && loadingCharts ? (
            <ChartSkeleton />
          ) : renderNoDataMessage ? (
            <div className="flex items-center justify-center h-full text-center text-gray-500 dark:text-gray-300">
              No data found
            </div>
          ) : (
            message
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(DialogModal);
